import React, { useState } from "react";
import { images } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import { useGlobal } from "../../context/GlobalContext";

const LoginScreen = () => {
  const { userData, updateUserData, loginByPassword } = useGlobal();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await loginByPassword();
  };

  return (
    <section className="login-section-bg">
      <div className="container-main d-flex flex-column justify-content-center">
        <div className="d-flex justify-content-center">
          <div className="auth-logo">
            <img
              src={images.pureTouchLogo}
              alt="app-logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = images.appLogo;
              }}
            />
          </div>
        </div>

        <div className="card auth-card mb-5">
          {/* <h3 className="mb-4 text-center text-primary fw-semibold">Login</h3> */}

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">
                E-mail
                {!userData.email && <span className="text-danger"> *</span>}
              </label>
              <input
                type="email"
                value={userData.email}
                onChange={(e) => updateUserData("email", e.target.value)}
                className="form-control input-tags"
                placeholder="Enter email"
              />
            </div>
            <div className="mb-2">
              <label className="form-label">
                Password
                {!userData.password && <span className="text-danger"> *</span>}
              </label>

              <div className="form-group position-relative mb-2">
                <input
                  type={showPassword ? "text" : "password"}
                  value={userData.password}
                  onChange={(e) => updateUserData("password", e.target.value)}
                  className="form-control input-tags input-tags-grouped"
                  placeholder="Enter password"
                />
                <span
                  className="eye-icon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i
                    className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                  ></i>
                </span>
              </div>
            </div>
            <div
              className="text-end cursor-pointer"
              onClick={() => navigate("/forgot-password")}
            >
              <p className="mb-0 text-primary fw-medium fs-13">
                Forgot Password?
              </p>
            </div>

            <div className="mt-4 text-center">
              <button type="submit" className="btn btn-primary mt-1">
                Login
              </button>
            </div>

            <div className="mt-3 text-center">
              <p className="fs-13 text-muted mb-0">
                By continuing, you agree to our{" "}
                <span
                  className="text-primary fw-medium cursor-pointer"
                  onClick={() => navigate("/terms")}
                >
                  Terms & Conditions
                </span>{" "}
                and{" "}
                <span
                  className="text-primary fw-medium cursor-pointer"
                  onClick={() => navigate("/privacy")}
                >
                  Privacy Policy
                </span>
                .
              </p>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default LoginScreen;
